export enum ReportingRole {
  View = "View",
  Create = "Create"
}
